import Dropdown from "../../Components/Fields/Dropdown";
import {
  CheckMandatory,
  DeleteRecord,
  ErrorAlert,
  getList,
  GetListDropdown,
  GetRecords,
  saveRecord,
  SuccessAlert,
  UpdateRecord,
  URLPRIFIX,
  WarningAlert,
} from "../../functions/api";
import React, { useEffect, useState, useMemo } from "react";
import { resolvePath, useLocation, useParams } from "react-router-dom";
import String from "../../Components/Fields/String";
import { useStore } from "../../Components/StateProvider";
import FormView from "../../Components/Elements/FormView";
import ListView from "../../Components/Elements/ListView";
import DatePicker from "../../Components/Fields/DatePicker";
import Journal from "../../Components/Fields/Journal";
import { getlocal } from "../../functions/localstorage";
import Attachement from "../../Components/Fields/Attachement";
import FileInput from "../../Components/Fields/FileInput";
import { PrimaryBTN, secondaryBTN } from "../../Constancs/cssconst";
import { FaEdit, FaCheck, FaTimes, FaTrash } from "react-icons/fa";


const ProjectForm = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { option, id } = useParams();
  const user = getlocal("system")?.user || {};
  const tablename = "project";
  const getrecord = `/project/getproject/${id}/11`;
  const updaterecord = "/project/updateproject/" + id + "/11";
  const setrecord = "/project/createproject/11";
  const [GenerateInvoice, setGenerateInvoice] = useState(false);
  const [CompanyNumber, setCompanyNumber] = useState("");
  const [CompanyList, setCompanyList] = useState([
    { label: "Please Choose", value: "" },
  ]);

  const store = useStore();
  const init = {
    projectName: "",
    projectDescription: "",
    startDate: "",
    endDate: "",
    priority: "",
    status: "Draft",
    film_id: "0",
    category_id: "",
    contact_id: "",
    activeStatus: true,
    child: [],
    attachmenturl: [],
  };

  useEffect(() => {
    store.setmodule("nonlitigation_project", init).then(() => {
      if (id != undefined) {
        store.setheader(option.toUpperCase() + " " + tablename);
        store.setprops("activeStatus", { hidden: false });
        store.setprops("category_id", { hidden: false, readonly: true });
        store.setprops(
          "projectName",
          queryParams.get("projectName")
            ? {
              mandatory: queryParams.get("projectName").includes("mandatory"),
              readonly: queryParams.get("projectName").includes("readonly"),
              hidden: queryParams.get("projectName").includes("hidden"),
            }
            : { mandatory: false }
        );
        store.setprops(
          "contact_id",
          queryParams.get("contact_id")
            ? {
              mandatory: queryParams.get("contact_id").includes("mandatory"),
              readonly: queryParams.get("contact_id").includes("readonly"),
              hidden: queryParams.get("contact_id").includes("hidden"),
            }
            : { mandatory: false, readonly: true }
        );
        store.setprops(
          "startDate",
          queryParams.get("startDate")
            ? {
              mandatory: queryParams.get("startDate")?.includes("mandatory"),
              readonly: queryParams.get("startDate")?.includes("readonly"),
              hidden: queryParams.get("startDate")?.includes("hidden"),
            }
            : { mandatory: false }
        );
        store.setprops(
          "endDate",
          queryParams.get("endDate")
            ? {
              mandatory: queryParams.get("endDate")?.includes("mandatory"),
              readonly: queryParams.get("endDate")?.includes("readonly"),
              hidden: queryParams.get("endDate")?.includes("hidden"),
            }
            : { mandatory: false }
        );
        store.setprops(
          "film_id",
          store.getvalue("film_id") != 0
            ? queryParams.get("film_id")
              ? {
                mandatory: queryParams.get("film_id")?.includes("mandatory"),
                readonly: queryParams.get("film_id")?.includes("readonly"),
                hidden: queryParams.get("film_id")?.includes("hidden"),
              }
              : { mandatory: false, readonly: true }
            : { mandatory: false, hidden: true }
        );
        store.setprops(
          "projectDescription",
          queryParams.get("projectDescription")
            ? {
              mandatory: queryParams
                .get("projectDescription")
                ?.includes("mandatory"),
              readonly: queryParams
                .get("projectDescription")
                ?.includes("readonly"),
              hidden: queryParams.get("projectDescription")?.includes("hidden"),
            }
            : { mandatory: false }
        );
        store.setprops(
          "priority",
          queryParams.get("priority")
            ? {
              mandatory: queryParams.get("priority")?.includes("mandatory"),
              readonly: queryParams.get("priority")?.includes("readonly"),
              hidden: queryParams.get("priority")?.includes("hidden"),
            }
            : { mandatory: false }
        );
        console.log("time-22-10-2025");
        LoadInitData();
        GetAssigntoList();
      } else {
        store.setheader("CREATE NEW " + tablename);
        store.setprops("activeStatus", { hidden: true });
        store.setprops("status", { hidden: true });
        store.setprops(
          "projectName",
          queryParams.get("projectName")
            ? {
              mandatory: queryParams.get("projectName").includes("mandatory"),
              readonly: queryParams.get("projectName").includes("readonly"),
              hidden: queryParams.get("projectName").includes("hidden"),
            }
            : { mandatory: true }
        );
        store.setprops(
          "category_id",
          queryParams.get("category_id")
            ? {
              mandatory: queryParams.get("category_id").includes("mandatory"),
              readonly: queryParams.get("category_id").includes("readonly"),
              hidden: queryParams.get("category_id").includes("hidden"),
            }
            : { mandatory: true }
        );
        store.setprops(
          "contact_id",
          queryParams.get("contact_id")
            ? {
              mandatory: queryParams.get("contact_id").includes("mandatory"),
              readonly: queryParams.get("contact_id").includes("readonly"),
              hidden: queryParams.get("contact_id").includes("hidden"),
            }
            : { mandatory: true }
        );
        store.setprops(
          "startDate",
          queryParams.get("startDate")
            ? {
              mandatory: queryParams.get("startDate")?.includes("mandatory"),
              readonly: queryParams.get("startDate")?.includes("readonly"),
              hidden: queryParams.get("startDate")?.includes("hidden"),
            }
            : { mandatory: true }
        );
        store.setprops(
          "endDate",
          queryParams.get("endDate")
            ? {
              mandatory: queryParams.get("endDate")?.includes("mandatory"),
              readonly: queryParams.get("endDate")?.includes("readonly"),
              hidden: queryParams.get("endDate")?.includes("hidden"),
            }
            : { mandatory: true }
        );
        store.setprops(
          "film_id",
          queryParams.get("film_id")
            ? {
              mandatory: queryParams.get("film_id")?.includes("mandatory"),
              readonly: queryParams.get("film_id")?.includes("readonly"),
              hidden: queryParams.get("film_id")?.includes("hidden"),
            }
            : store.getvalue("category_id") == "1" || store.getvalue("category_id") == "9"
              ? {
                mandatory: true,
                hidden: false,
              }
              : {
                mandatory: false,
                hidden: true,
              }
        );
        store.setprops(
          "priority",
          queryParams.get("priority")
            ? {
              mandatory: queryParams.get("priority")?.includes("mandatory"),
              readonly: queryParams.get("priority")?.includes("readonly"),
              hidden: queryParams.get("priority")?.includes("hidden"),
            }
            : { mandatory: false }
        );
        store.setprops(
          "projectDescription",
          queryParams.get("projectDescription")
            ? {
              mandatory: queryParams
                .get("projectDescription")
                ?.includes("mandatory"),
              readonly: queryParams
                .get("projectDescription")
                ?.includes("readonly"),
              hidden: queryParams.get("projectDescription")?.includes("hidden"),
            }
            : { mandatory: false, readonly: false }
        );
      }
      GetListDropdown({
        listUrl: "/clientcategory/getClientCategorylist",
        field: "categoryName",
        sort: "asc",
        count: 10000,
        store: store,
      });
      GetListDropdown({
        listUrl: "/api/FilmMaster/getfilms",
        field: "film_name",
        sort: "asc",
        count: 10000,
        store: store,
      });
      GetClientList_From_Contacts();
    });
  }, [option, id]);

  function LoadInitData() {
    GetRecords(getrecord).then(async (res) => {
      if (res.success) {
        let records = {
          ...init,
          projectName: res.record.parent.projectName,
          projectDescription: res.record.parent.projectDescription,
          startDate: res.record.parent.startDate,
          endDate: res.record.parent.endDate,
          priority: res.record.parent.priority,
          status: res.record.parent.status,
          film_id: res.record.parent.film_id,
          contact_id: res.record.parent.contact_id,
          category_id: res.record.parent.category_id,
          activeStatus: res.record.parent.activeStatus,
          attachmenturl: res.record.parent.attachmenturl || [],
        };

        if (option === "view") {
          store.setprops("projectName", { hidden: false, readonly: true });
          store.setprops("projectDescription", {
            hidden: false,
            readonly: true,
          });
          store.setprops("startDate", { hidden: false, readonly: true });
          store.setprops("endDate", { hidden: false, readonly: true });
          store.setprops("priority", { hidden: false, readonly: true });
          store.setprops("status", { hidden: false, readonly: true });
          store.setprops(
            "film_id",
            res.record.parent.category_id == 1 || res.record.parent.category_id == 9
              ? { readonly: true }
              : { hidden: true }
          );
          store.setprops("contact_id", { hidden: false, readonly: true });
          store.setprops("category_id", { hidden: false, readonly: true });
          store.setprops("activeStatus", { hidden: false, readonly: true });
          records.child = {};
          if (res?.record?.tasks?.length > 0) {
            var tasks = res?.record?.tasks || [];
            tasks = tasks.map((item) => {
              if (item.type == 11) {
                item.type = "Non-Litigation";
              } else if (item.type == 12) {
                item.type = "Litigation";
              } else if (item.type == 13) {
                item.type = "TradeMark";
              }
              if (item.assigned_to == 0) {
                item.assigned_to_username = "UnAssigned";
              }
              return { ...item, activeStatus: item.activeStatus ? "Active" : "InActive" };
            });

            records.child.tasks = {
              list: tasks,
              header: getlocal("properties").nonlitigation_tasks.update
                ? [
                  ["Task Title", "subtask_title"],
                  ["Document", "document_name"],
                  ["Type", "type"],
                  ["Priority", "priority"],
                  ["Assigned To", "assigned_to_username"],
                  ["Status", "status"],
                  ["Due Date", "dueDate"],
                  ["ActiveStatus", "activeStatus"],
                ]
                : [
                  ["Task Title", "subtask_title"],
                  ["Document", "document_name"],
                  ["Type", "type"],
                  ["Priority", "priority"],
                  ["Assigned To", "assigned_to_username"],
                  ["Status", "status"],
                  ["Due Date", "dueDate"],
                  ["ActiveStatus", "activeStatus"],
                  ["Action", "ACTION"],
                ],
            };
          }
          if (res?.record?.documents?.length > 0) {
            var documents = res?.record?.documents || [];
            documents = documents.map((item) => ({
              ...item,
              activeStatus: item.activeStatus ? "Active" : "InActive",
              assigned_to_username: item.assigned_to === 0 ? "UnAssigned" : item.assigned_to_username,
            }));
            records.child.documents = {
              list: documents,
              header: [
                ["Document Name", "task_title"],
                ["Priority", "priority"],
                ["Assigned To", "assigned_to_username"],
                ["Due Date", "dueDate"],
                ["Status", "status"],
                ["ActiveStatus", "activeStatus"],
                ["Action", "ACTION"],
              ],
            };
          }
          if (res?.record?.invoices?.length > 0) {
            records.child.invoices = {
              list: res?.record?.invoices,
              header: [
                ["Invoice No", "invoice_no"],
                ["Company Name", "company_Name"],
                ["Amount", "invoice_total"],
                ["Due Amount", "invoice_due_amount"],
                ["Due Date", "invoice_due_date"],
                ["Status", "invoice_status"],
                ["Action", "ACTION"],
              ],
            };
          }
        } else if (option === "edit") {
          store.setprops(
            "film_id",
            res.record.parent.category_id == 1 || res.record.parent.category_id == 9
              ? { readonly: true }
              : { hidden: true }
          );
          store.setprops("status", { hidden: false, readonly: false });
        }
        store.reset(records);
      }
    });
  }

  async function GetAssigntoList() {
    GetListDropdown({
      listUrl: "/users/getusers",
      field: "userName",
      sort: "asc",
      count: 100,
      store: store,
    });
    await getList({
      listUrl: "/users/getusers",
      field: "userName",
      sort: "asc",
      count: 10000,
    }).then((users) => {
      if (users.success) {
        users = users?.data?.list || [];
        users = users.map((user) => ({
          ...user,
          value: user.id,
          label: user.firstName + " " + user.lastName,
        }));
        users.splice(0, 0, {
          value: 0,
          label: "UnAssigned",
        });
        store.setprops("userName_list", users);
      }
    });
  }

  function update() {
    store.startLoading();
    let data = store.getrecord();
    data.modifiedBy = store.getuser().id;
    data.id = Number(id);
    if (typeof data.activeStatus === "string") {
      data.activeStatus = data.activeStatus == "true" ? true : false;
    }
    if (CheckDueDates(data.startDate, data.endDate)) {
      UpdateRecord(updaterecord, data).then((res) => {
        if (res.success) {
          store.stopLoading();
          SuccessAlert("Project Updated Successfully");
          store.navTo(
            "/" + URLPRIFIX + "/projects/view/" + res.Id.response.id,
            { replace: true }
          );
        } else {
          store.stopLoading();
          ErrorAlert(
            res?.errormessage?.data || "Error Found Please contact the Admin"
          );
        }
      });
    } else {
      store.stopLoading();
    }
  }

  function Submit() {
    store.startLoading();
    let data = store.getrecord();
    data.modifiedBy = store.getuser().id;
    data.createdBy = store.getuser().id;
    if (typeof data.activeStatus === "string") {
      data.activeStatus = data.activeStatus == "true" ? true : false;
    }
    if (
      CheckMandatory("nonlitigation_project", store) &&
      CheckDueDates(data.startDate, data.endDate)
    ) {
      saveRecord(setrecord, data).then((res) => {
        if (res.success) {
          store.stopLoading();
          SuccessAlert("Project Submitted Successfully");
          store.navTo(
            "/" + URLPRIFIX + "/projects/view/" + res.Id.projectDetails.id,
            { replace: true }
          );
        } else {
          store.stopLoading();
          ErrorAlert(
            res?.errormessage?.response?.data ||
            "Error Found Please contact the Admin"
          );
        }
      });
    } else {
      store.stopLoading();
    }
  }

  function CheckDueDates(projectdate = "", dueDate = "") {
    let out = true;
    if (projectdate != "" && dueDate != "") {
      if (new Date(projectdate) > new Date(dueDate)) {
        WarningAlert("The start date must be earlier than the end date.");
        out = false;
        store.stopLoading();
      }
    }
    return out;
  }

  function categoryNameChange(category_id) {
    GetClientList_From_Contacts({}, category_id);
    category_id = store
      .getprops("categoryName_list")
      .find((item) => item.value == category_id);
    if (category_id != undefined && (category_id.id == "1" || category_id.id == "9")) {
      store.setprops(
        "film_id",
        queryParams.get("film_id")
          ? {
            mandatory: queryParams.get("film_id")?.includes("mandatory"),
            readonly: queryParams.get("film_id")?.includes("readonly"),
            hidden: false,
          }
          : { mandatory: true, hidden: false }
      );
    } else {
      store.setprops("film_id", { mandatory: false, hidden: true });
    }
    store.setvalue("film_id", "0");
  }

  function FilmNameChange(film_id) {
    GetRecords("/api/FilmMaster/films/" + film_id).then((res) => {
      if (res.success) {
        res = res?.record?.response[0]?.film_name;
        getList({
          listUrl: "/contact/getcontacts",
          field: "film_name",
          search: res,
          sort: "asc",
          page: 1,
          count: 10000,
        }).then((reslist) => {
          if (reslist.success) {
            reslist = reslist?.data?.list;
            if (reslist.length > 0) {
              store.setvalue("contact_id", reslist[0]?.client_id || "");
            } else {
              store.setvalue("contact_id", "");
            }
            let list = [];
            for (let record of reslist) {
              list.push({ value: record.client_id, label: record.clientName });
            }
            store.setprops("clientname_list", list);
          }
        });
      }
    });
  }

  function ClientNameChange(client_id) {
    let client = store
      .getprops("clientname_list")
      .find((item) => item.value == client_id);
  }

  async function GetClientList_From_Contacts(
    film = {},
    category_id = store.getvalue("category_id")
  ) {
    if (category_id == "1" || category_id == "9") {
      await getList({
        listUrl: "/contact/getcontacts",
        count: 10000,
        field: "film_name",
        search: film.label,
      }).then((contacts) => {
        if (contacts.success) {
          contacts = contacts?.data?.list || [];
          let clientList = [];
          contacts
            .map((contact) => {
              if (
                contact.client_id != undefined &&
                contact.clientName != undefined &&
                contact.client_id != "" &&
                contact.clientName != "" &&
                !clientList.some((client) => client.label === contact.clientName)
              ) {
                clientList.push({
                  value: contact.client_id,
                  label: contact.clientName,
                });
              }
            })
            .filter((item) => item != undefined);
          store.setprops("clientname_list", clientList);
        }
      });
    } else {
      await getList({
        listUrl: "/api/v2/Customer/getclients",
        count: 10000,
      }).then((clients) => {
        if (clients.success) {
          clients = clients?.data?.list || [];
          clients = clients.map((client) => ({
            value: client.id,
            label: client.clientname,
          }));
          store.setprops("clientname_list", clients);
        }
      });
    }
  }

  function NavigateToInvoice(company_id) {
    let contact_id = store.getvalue("contact_id");
    store.navTo(
      "/" +
      URLPRIFIX +
      "/" +
      company_id +
      "/accounts/invoice/create?proj_id=" +
      id +
      "&cust_id=" +
      contact_id
    );
  }

  return (
    <FormView
      actions={[
        {
          Name: "Back",
          onclick: () => {
            store.navback();
            store.reset(init);
          },
          visible: true,
        },
        {
          Name: "Edit",
          onclick: () => {
            store.navTo(`/${URLPRIFIX}/projects/edit/${id}`, {
              replace: true,
            });
          },
          visible: option === "view" && store.getprops("update"),
        },
        {
          Name: "Generate Invoice",
          onclick: () => {
            GetRecords(
              "/contact/companycontacts/" + store.getvalue("contact_id")
            ).then((client) => {
              if (client.success) {
                client = client?.record || {};
                client = client?.company_id?.map((item) => ({
                  value: item.company_id,
                  label: item.company_name,
                }));
                setCompanyList((prev) => {
                  return [...prev, ...client];
                });
              }
            });
            setGenerateInvoice(true);
          },
          type: "primary",
          visible: option === "view" && [1, 4].includes(user.role),
        },
        {
          Name: "Submit",
          onclick: Submit,
          type: "primary",
          visible: id === undefined,
        },
        {
          Name: "Update",
          onclick: update,
          type: "primary",
          visible: option === "edit" && store.getprops("update"),
        },
        {
          Name: "Create Document",
          type: "primary",
          onclick: () => {
            let data = store.getrecord();
            store.setrecord("nonlitigation_document", {
              project_id: id,
              form_id:
                data.film_id != 0 && data.film_id != undefined ? "0" : "",
              film_id: data.film_id,
              contact_id: data.contact_id,
              assigned_to: "0",
              task_title: "",
              dueDate: "",
              priority: "Medium",
              editor_id: "0",
              status: "Draft",
              description: "",
              attachmenturl: [],
              activeStatus: true,
              child: [],
            });
            let url =
              "/demo/documents/create?project_id=readonly&contact_id=readonly";
            if (data.film_id != 0 && data.film_id != undefined)
              url += "&film_id=readonly&form_id=mandatory";
            store.navTo(url);
          },
          visible:
            option === "view" &&
            getlocal("properties")?.nonlitigation_documents?.add,
        },
      ]}
    >
      {GenerateInvoice && (
        <div className="absolute flex h-[80%] w-[95%] rounded-lg z-50 bg-black bg-opacity-15 backdrop-blur-sm justify-center items-center">
          <div className="flex flex-col items-center bg-secondary px-20 py-5 rounded-lg">
            <h1 className="font-bold">Please confirm the Company</h1>
            <div className="flex flex-col pt-6 pb-10 w-[80%]">
              <label>Company Name</label>
              <select
                className="flex w-full border rounded-lg"
                onChange={(event) => {
                  setCompanyNumber(event.target.value);
                }}
              >
                {CompanyList.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex justify-evenly w-full">
              <button
                className={secondaryBTN}
                onClick={() => {
                  setGenerateInvoice(false);
                }}
              >
                Back
              </button>
              <button
                className={PrimaryBTN}
                onClick={() => {
                  if (CompanyNumber != "") {
                    NavigateToInvoice(CompanyNumber);
                  } else {
                    ErrorAlert("Please choose the company for generate invoice.");
                  }
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="grid grid-cols-2 max-md:grid-cols-1 gap-6">
        <String name="projectName" label="Project Name :" />
        <Dropdown
          name="category_id"
          label="Category :"
          list={store.getprops("categoryName_list")}
          onchange={categoryNameChange}
        />
        <Dropdown
          name="contact_id"
          label="Customer :"
          list={store.getprops("clientname_list")}
        />
        <Dropdown
          name="film_id"
          label="Film :"
          list={store.getprops("film_name_list")}
          onchange={FilmNameChange}
          onAdd={() => {
            store.navTo("/" + URLPRIFIX + "/filmmaster/create");
          }}
        />
        <Dropdown
          name="priority"
          label="Priority :"
          list={[
            { value: "High", label: "High" },
            { value: "Medium", label: "Medium" },
            { value: "Low", label: "Low" },
          ]}
        />
        <Dropdown
          name="status"
          label="Status :"
          list={[
            { value: "Draft", label: "Draft" },
            { value: "inprogress", label: "InProgress" },
            { value: "hold", label: "Hold" },
            { value: "completed", label: "Completed" },
            { value: "billed", label: "Billed" },
          ]}
        />
        <Dropdown
          name="activeStatus"
          label="Active Status :"
          list={[
            { value: true, label: "Active" },
            { value: false, label: "InActive" },
          ]}
        />
        <div className="col-span-2 max-md:col-span-1">
          <Journal
            name="projectDescription"
            label="Project Description :"
            doubleline={true}
          />
        </div>
        <DatePicker name="startDate" label="Start Date :" />
        <DatePicker name="endDate" label="End Date :" />
        <div className="col-span-2 max-md:col-span-1 px-2">
          <div className="font-bold text-[20px]">Attachments</div>
          <div className="grid grid-cols-5">
            {store.getvalue("attachmenturl")?.length > 0 ? (
              store.getvalue("attachmenturl").map((item, index) => (
                <div
                  key={index}
                  className="col-span-1 flex border-r pr-6 w-full items-center"
                >
                  <Attachement name={"attachmenturl"} fileurl={item} />
                  <button
                    className="hover:bg-tertiary p-1 h-fit w-fit rounded-full"
                    onClick={() => {
                      let arr = [];
                      store
                        .getvalue("attachmenturl")
                        .map((attachitem, attachindex) => {
                          if (attachindex !== index) {
                            arr.push(attachitem);
                          }
                        });
                      store.setvalue("attachmenturl", arr);
                    }}
                  >
                    X
                  </button>
                </div>
              ))
            ) : (
              <>No Data</>
            )}
            {option !== "view" && (
              <FileInput
                prefix={"TASK" + id}
                onchange={(file) => {
                  let attachmenturl = store.getvalue("attachmenturl") || [];
                  attachmenturl.push(file);
                  store.setvalue("attachmenturl", attachmenturl);
                }}
              />
            )}
          </div>
        </div>
        {option === "view" && (
          <ChildTabsView
            className="col-span-2 max-md:col-span-1 mt-1"
            tabsList={store.getvalue("child") || {}}
            store={store}
            LoadInitData={LoadInitData}
          />
        )}
      </div>
    </FormView>
  );
};

function ChildTabsView({ tabsList = {}, className = "", store, LoadInitData }) {
  const props = getlocal("properties");
  const user = getlocal("system")?.user || {};
  const [tabs, setTabs] = useState(
    props.nonlitigation_document.view ? "documents" : "tasks"
  );
  const [selected, setSelected] = useState([]);
  const [bulkAssignedTo, setBulkAssignedTo] = useState(0);
  const [bulkDueDate, setBulkDueDate] = useState("");

  const tabConfigs = [
    { key: "documents", label: "Documents" },
    { key: "tasks", label: "Tasks" },
    { key: "invoices", label: "Invoices" },
  ];

  const handleSelect = (record, isSelected) => {
    setSelected((prev) =>
      isSelected
        ? [...prev, record]
        : prev.filter((item) => item.id !== record.id)
    );
  };

  const handleBulkUpdate = async () => {
    if (selected.length === 0) {
      ErrorAlert("No items selected for bulk update.");
      return;
    }
    if (bulkAssignedTo <= 0) {
      ErrorAlert("Please select an assignee for the bulk update.");
      return;
    }

    const endpoint =
      tabs === "documents"
        ? "/tasks/bulkupdatedocuments/11"
        : "/subtask/bulkupdatetasks/11";
    const requestPayload = {
      task_ids: selected.map((item) => item.id),
      assigned_to: bulkAssignedTo,
      due_date: bulkDueDate ? new Date(bulkDueDate).toISOString() : null,
      modified_by: user.id,
    };

    try {
      const result = await UpdateRecord(endpoint, requestPayload);
      if (result.success) {
        SuccessAlert(`Bulk update successful for ${result.updatedCount || selected.length} items.`);
        LoadInitData();
        setSelected([]);
        setBulkAssignedTo(0);
        setBulkDueDate("");
      } else {
        ErrorAlert(result?.errormessage?.data || "Bulk update failed. Please try again.");
      }
    } catch (error) {
      ErrorAlert("An error occurred during bulk update. Please contact the admin.");
    }
  };

  const handleSaveEdit = async (updatedRow) => {
    try {
      let endpoint = "";
      if (tabs === "documents") {
        endpoint = `/tasks/updatetask/${updatedRow.id}/11`;
      } else if (tabs === "tasks") {
        endpoint = `/subtask/updatesubtask/${updatedRow.id}`;
      } else if (tabs === "invoices") {
        endpoint = `/invoices/updateinvoice/${updatedRow.id}`;
      }

      const payload = {
        ...updatedRow,
        activeStatus: updatedRow.activeStatus === "Active" ? true : false,
        modifiedBy: user.id,
      };
      if (!payload.priority) payload.priority = "Medium";
      if (!payload.status) payload.status = "Draft";
      const result = await UpdateRecord(endpoint, payload);
      if (result.success) {
        SuccessAlert("Updated successfully");
        LoadInitData();
      } else {
        ErrorAlert("Update failed: " + (result?.errormessage?.data || "Unknown error"));
      }
    } catch (err) {
      ErrorAlert("Unexpected error occurred.");
    }
  };

  const enrichedTabsList = useMemo(() => {
    const userMap = Object.fromEntries(
      (store.getprops("userName_list") || []).map((u) => [u.value, u.label])
    );

    const newTabsList = { ...tabsList };

    if (tabsList.documents?.list) {
      const enrichedList = tabsList.documents.list.map((doc) => ({
        ...doc,
        assigned_to_username: userMap[doc.assigned_to] || "UnAssigned",
        activeStatus: doc.activeStatus ? "Active" : "InActive",
      }));

      newTabsList.documents = {
        ...tabsList.documents,
        list: enrichedList,
        header: [
          ["Document Name", "task_title"],
          ["Priority", "priority"],
          ["Assigned To", "assigned_to_username"],
          ["Due Date", "dueDate"],
          ["Status", "status"],
          // ["ActiveStatus", "activeStatus"],
          // ["Action", "ACTION"],
        ],
      };
    }

    if (tabsList.tasks?.list) {
      const enrichedList = tabsList.tasks.list.map((task) => ({
        ...task,
        assigned_to_username: userMap[task.assigned_to] || "UnAssigned",
        activeStatus: task.activeStatus ? "Active" : "InActive",
      }));

      newTabsList.tasks = {
        ...tabsList.tasks,
        list: enrichedList,
        header: [
          ["Task Title", "subtask_title"],
          ["Document", "document_name"],
          ["Type", "type"],
          ["Priority", "priority"],
          ["Assigned To", "assigned_to_username"],
          ["Status", "status"],
          ["Due Date", "dueDate"],
          //  ["ActiveStatus", "activeStatus"],
          // ["Action", "ACTION"],
        ],
      };
    }

    if (tabsList.invoices?.list) {
      newTabsList.invoices = {
        ...tabsList.invoices,
        header: [
          ["Invoice No", "invoice_no"],
          ["Company Name", "company_Name"],
          ["Amount", "invoice_total"],
          ["Due Amount", "invoice_due_amount"],
          ["Due Date", "invoice_due_date"],
          ["Status", "invoice_status"],
          ["Action", "ACTION"],
        ],
      };
    }

    return newTabsList;
  }, [tabsList, store.getprops("userName_list")]);

  const dropdownOptions = {
    assigned_to_username: store.getprops("userName_list") || [
      { value: 0, label: "UnAssigned" },
    ],
    priority: [
      { value: "High", label: "High" },
      { value: "Medium", label: "Medium" },
      { value: "Low", label: "Low" },
    ],
    status: [
      { value: "Draft", label: "Draft" },
      { value: "inprogress", label: "InProgress" },
      { value: "hold", label: "Hold" },
      { value: "completed", label: "Completed" },
      { value: "billed", label: "Billed" },
    ],
  };

  return (
    <div className={className}>
      <div className="flex justify-between items-center border-b border-gray-200 dark:border-gray-700 dark:text-gray-400">
        <ul
          className={
            className +
            " flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700"
          }
        >
          {tabConfigs.map(({ key, label }) => {
            const hasItems = tabsList?.[key]?.list?.length > 0;
            if (!hasItems) return null;
            const isActive = tabs === key;

            return (
              <li key={key} className="me-2">
                <button
                  className={
                    "p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary " +
                    (isActive ? "bg-Ocean_Blue text-secondary" : "bg-Alice_Blue")
                  }
                  onClick={() => setTabs(key)}
                >
                  {`${label}${isActive ? ` - ${enrichedTabsList[key]?.list?.length || 0}` : ""}`}
                </button>
              </li>
            );
          })}
        </ul>
        {["documents", "tasks"].includes(tabs) && selected.length > 0 && (
          <div className="flex items-center gap-2 px-2">
            <Dropdown
              className={{ lable: "min-w-fit", field: "", input: "" }}
              name="bulk_assigned_to"
              label="Assigned To:"
              list={dropdownOptions.assigned_to_username}
              value={bulkAssignedTo}
              onchange={(value) => setBulkAssignedTo(value)}
            />
            <DatePicker
              name="bulk_due_date"
              label="Due Date (Optional):"
              value={bulkDueDate}
              onchange={(value) => setBulkDueDate(value)}
            />
            <button
              className="py-2 px-6 rounded-xl font-bold text-[12px] bg-primary text-secondary"
              onClick={handleBulkUpdate}
            >
              Save
            </button>
          </div>
        )}
      </div>
      <EditableTable
        headers={enrichedTabsList[tabs]?.header || []}
        records={enrichedTabsList[tabs]?.list || []}
        selected={selected}
        onSelect={handleSelect}
        onRowClick={(item) => {
          if (tabs === "tasks") {
            if (item.type == "Non-Litigation") {
              store.navTo("/" + URLPRIFIX + "/tasks/view/" + item?.id);
            } else if (item.type == "Litigation") {
              store.navTo(
                "/" + URLPRIFIX + "/litigation/tasks/view/" + item?.id
              );
            } else if (item.type == "TradeMark") {
              store.navTo(
                "/" + URLPRIFIX + "/trademark/tasks/view/" + item?.id
              );
            }
          } else if (tabs === "documents") {
            store.navTo("/" + URLPRIFIX + "/documents/view/" + item?.id);
          }
          else if (tabs === "invoices") {
            store.navTo(
              "/" +
              URLPRIFIX +
              "/" +
              item.company_id +
              "/accounts/invoice/view/" +
              item?.id
            );
          }
        }}
        ondelete={
          tabs === "documents" && props.nonlitigation_documents.delete
            ? (item) => {
              DeleteRecord("/tasks/deletetask/" + item.id, {
                modifiedBy: store.getuser().id,
              }).then((res) => {
                if (res.success) {
                  SuccessAlert("Deleted Successfully");
                  LoadInitData();
                }
                else if (res.code == 302) {
                  WarningAlert("User cancelled deletion")
                }
                else {
                  ErrorAlert(
                    res?.errormessage?.response?.data ||
                    "Unknown Error Found Please contact the Admin"
                  );
                }
              });
            }
            : tabs === "tasks" && props.nonlitigation_tasks.delete
              ? (item) => {
                DeleteRecord("/subtask/deletesubtask/" + item.id, {
                  modifiedBy: store.getuser().id,
                }).then((res) => {
                  if (res.success) {
                    SuccessAlert("Deleted Successfully");
                    LoadInitData();
                  } else {
                    ErrorAlert(
                      res?.errormessage?.response?.data ||
                      "Unknown Error Found Please contact the Admin"
                    );
                  }
                });
              }
              : tabs === "invoices" && props.invoices.delete
                ? (item) => {
                  DeleteRecord("/invoices/deleteinvoice/" + item.id, {
                    modifiedBy: store.getuser().id,
                  }).then((res) => {
                    if (res.success) {
                      SuccessAlert("Deleted Successfully");
                      LoadInitData();
                    } else {
                      ErrorAlert(
                        res?.errormessage?.response?.data ||
                        "Unknown Error Found Please contact the Admin"
                      );
                    }
                  });
                }
                : undefined
        }
        onSaveEdit={handleSaveEdit}
        dropdownOptions={dropdownOptions}
        dateFields={["dueDate"]}
      />
    </div>
  );
}

function EditableTable({
  headers,
  records,
  selected,
  onSelect,
  onRowClick,
  onSaveEdit,
  ondelete,
  dropdownOptions = {},
  dateFields = [],
}) {
  const [editRowId, setEditRowId] = useState(null);
  const [editData, setEditData] = useState({});

  const handleCheckboxChange = (record, isChecked) => {
    onSelect(record, isChecked);
  };

  const handleBulkSelect = (e) => {
    const isChecked = e.target.checked;
    records.forEach((rec) => onSelect(rec, isChecked));
  };

  const startEdit = (record) => {
    setEditRowId(record.id);
    setEditData({ ...record });
  };

  const saveEdit = () => {
    if (editRowId !== null) {
      onSaveEdit(editData);
      setEditRowId(null);
    }
  };

  const cancelEdit = () => {
    setEditRowId(null);
    setEditData({});
  };

  return (
    <table className="min-w-full border mt-4">
      <thead className="bg-gray-100">
        <tr>
          <th className="p-2 border">
            <input
              type="checkbox"
              checked={selected.length === records.length && records.length > 0}
              onChange={handleBulkSelect}
              onClick={(e) => e.stopPropagation()}
            />
          </th>
          <th className="p-2 border">S.No</th>
          {headers.map(([label, key]) => (
            <th key={key} className="p-2 border text-left">
              {label}
            </th>
          ))}
          <th className="p-2 border">Actions</th>
        </tr>
      </thead>
      <tbody>
        {records.map((row, index) => {
          const isSelected = selected.some((s) => s.id === row.id);
          const isEditing = editRowId === row.id;
          const titleColumnKey = headers[0]?.[1];

          return (
            <tr
              key={row.id}
              className={`hover:bg-gray-50 ${isEditing ? "bg-yellow-50" : ""}`}
            // onClick={() => {
            //   if (!isEditing) onRowClick(row);
            // }}
            >
              <td className="p-2 border">
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={(e) => handleCheckboxChange(row, e.target.checked)}
                  onClick={(e) => e.stopPropagation()}
                />
              </td>
              <td className="p-2 border">{index + 1}</td>
              {headers.map(([label, key]) => (
                <td key={key} className="p-2 border">
                  {isEditing ? (
                    dropdownOptions[key] ? (
                      <select
                        className="border p-1 w-full"
                        value={
                          key === "assigned_to_username"
                            ? editData.assigned_to
                            : editData[key] || ""
                        }
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            [key === "assigned_to_username" ? "assigned_to" : key]:
                              e.target.value,
                          })
                        }
                        onClick={(e) => e.stopPropagation()}
                      >
                        <option value="">Select</option>
                        {dropdownOptions[key].map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    ) : dateFields.includes(key) ? (
                      <input
                        type="date"
                        className="border p-1 w-full"
                        value={editData[key] ? editData[key].slice(0, 10) : ""}
                        onChange={(e) => {
                          const isoDate = e.target.value
                            ? new Date(e.target.value).toISOString()
                            : "";
                          setEditData({ ...editData, [key]: isoDate });
                        }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    ) : (
                      <input
                        className="border p-1 w-full"
                        value={editData[key] || ""}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            [key]: e.target.value,
                          })
                        }
                        onClick={(e) => e.stopPropagation()}
                      />
                    )
                  ) : (
                    key === titleColumnKey ? (
                      /* **TITLE CELL: CLICKABLE + HIGHLIGHTED** */
                      <div
                        className="cursor-pointer text-blue-600 hover:text-blue-800 hover:underline font-semibold flex items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          onRowClick(row);
                        }}
                      >
                        <span className="mr-1 text-xs">🔗</span>
                        {row[key]}
                      </div>
                    ) : (
                      /* **OTHER CELLS: NON-CLICKABLE** */
                      <span className="cursor-default">{row[key]}</span>
                    )
                  )}
                </td>
              ))}
              <td className="p-2 border whitespace-nowrap">
                {isEditing ? (
                  <>
                    <button
                      className="text-green-600 mr-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        saveEdit();
                      }}
                    >
                      <FaCheck />
                    </button>
                    <button
                      className="text-gray-600"
                      onClick={(e) => {
                        e.stopPropagation();
                        cancelEdit();
                      }}
                    >
                      <FaTimes />
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="text-blue-600 mr-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        startEdit(row);
                      }}
                    >
                      <FaEdit />
                    </button>
                    {ondelete && (
                      <button
                        className="text-red-600"
                        onClick={(e) => {
                          e.stopPropagation();
                          ondelete(row);
                        }}
                      >
                        <FaTrash />
                      </button>
                    )}
                  </>
                )}
              </td>
            </tr>
          );
        })}
        {records.length === 0 && (
          <tr>
            <td
              colSpan={headers.length + 3}
              className="text-center p-4 text-gray-500"
            >
              No records found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default ProjectForm;
